import { Module } from 'vuex';

import { UserState } from '../../models';

import { ClearModuleAction } from '../../store/user/actions/clear-module.action';
import { LoadUserAction } from '../../store/user/actions/load-user.action';
import { PersistUserAction } from '../../store/user/actions/persist-user.action';
import { UserGetter } from '../../store/user/getters/user.getter';
import { ClearModuleMutation } from '../../store/user/mutations/clear-module.mutation';
import { SetUserMutation } from '../../store/user/mutations/set-user.mutation';
import { USER_CONSTS } from '../../store/user/user.consts';

export const USER_MODULE: Module<UserState, any> = {
  namespaced: true,

  state: (): UserState => {
    return {
      user: undefined
    };
  },

  getters: {
    [USER_CONSTS.getters.user]: UserGetter.execute
  },

  actions: {
    [USER_CONSTS.actions.loadUser]: LoadUserAction.execute,
    [USER_CONSTS.actions.persistUser]: PersistUserAction.execute,
    [USER_CONSTS.actions.clearModule]: ClearModuleAction.execute
  },

  mutations: {
    [USER_CONSTS.mutations.setUser]: SetUserMutation.execute,
    [USER_CONSTS.mutations.clearModule]: ClearModuleMutation.execute
  }

};
